import { render, staticRenderFns } from "./PriceRLS.vue?vue&type=template&id=62f8e59c&scoped=true&"
import script from "./PriceRLS.vue?vue&type=script&lang=js&"
export * from "./PriceRLS.vue?vue&type=script&lang=js&"
import style0 from "./PriceRLS.vue?vue&type=style&index=0&id=62f8e59c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f8e59c",
  null
  
)

export default component.exports